import { STATS, GALLERY } from "@/data/content";
import { Reveal } from "./Reveal";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 sm:py-32 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <Reveal>
          <div className="grid grid-cols-3 gap-6 mb-12">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`stat-${s.label}`} className="border-l-2 border-gold pl-4">
                <div className="font-display text-3xl sm:text-4xl lg:text-5xl text-forest">
                  {s.value}
                </div>
                <div className="mt-2 text-xs sm:text-sm uppercase tracking-wider text-forest/60">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          <div className="relative overflow-hidden">
            <img
              src={`${GALLERY[0].url}?auto=format&fit=crop&w=900&q=80`}
              alt="Landscaped luxury garden with deck"
              className="w-full h-[340px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 border border-gold/30" />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="text-sm uppercase tracking-[0.3em] text-gold font-semibold mb-4">
            Rooted in Brantford
          </p>
          <h2 className="font-display text-forest text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight mb-8">
            Craftsmen of the Living Landscape
          </h2>
          <div className="space-y-6 text-forest/75 text-base lg:text-lg leading-relaxed">
            <p>
              For over fifteen years, Canopy Grounds has been shaping the outdoor
              spaces of Brantford and its surrounding communities: Paris, Cambridge,
              Ancaster and beyond. What began as a single pickup truck and a passion
              for the land has grown into the region's most trusted name in premium
              landscaping.
            </p>
            <p>
              We believe a yard is more than grass and gravel. It's where mornings
              begin, where children play, where evenings slow down. Every project we
              touch is guided by a single promise: to transform ordinary ground into
              a sanctuary you'll never want to leave.
            </p>
          </div>

          <a
            href="#quote"
            data-testid="about-cta"
            className="inline-block mt-10 bg-forest text-cream px-9 py-4 text-sm font-semibold uppercase tracking-[0.15em] hover:bg-forest-hover transition-colors duration-300"
          >
            Start Your Project
          </a>
        </Reveal>
      </div>
    </section>
  );
};
